import React from 'react';
import { Button } from 'react-bootstrap';

export const REPORT_STATUS = {
    pending:   { label: 'En verificación', style: { background: '#fef9c3', color: '#854d0e', border: '1px solid #fde047' } },
    confirmed: { label: 'Confirmado',      style: { background: '#dcfce7', color: '#166534', border: '1px solid #86efac' } },
    rejected:  { label: 'Rechazado',       style: { background: '#fef2f2', color: '#991b1b', border: '1px solid #fecaca' } },
};

export const SOURCE_LABEL = {
    provider: 'Reportado por el proveedor',
    superadmin: 'Registrado por Abi',
};

export function StatusBadge({ status }) {
    const cfg = REPORT_STATUS[status];
    if (!cfg) return null;
    return <span className="report-status-badge" style={cfg.style}>{cfg.label}</span>;
}

// 'YYYY-MM-DD' -> 'DD/MM/YYYY' sin pasar por Date (evita corrimientos de zona horaria).
export function formatDate(ymd) {
    if (!ymd) return '—';
    const [y, m, d] = String(ymd).slice(0, 10).split('-');
    return `${d}/${m}/${y}`;
}

export function formatDateTime(iso) {
    if (!iso) return '—';
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? '—' : d.toLocaleString('es-CO');
}

// Fecha local de hoy en 'YYYY-MM-DD' (para el `max` del input date).
export function todayIso() {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function apiError(err, fallback = 'Ocurrió un error. Intenta de nuevo.') {
    const data = err?.response?.data;
    const firstField = data?.errors ? Object.values(data.errors)[0]?.[0] : null;
    return firstField || data?.message || fallback;
}

export function apiFieldErrors(err) {
    const errors = err?.response?.data?.errors || {};
    return Object.fromEntries(Object.entries(errors).map(([k, v]) => [k, v?.[0]]));
}

export function Pager({ page, onChange }) {
    if (!page || page.last_page <= 1) return null;
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8, marginTop: 10 }}>
            <Button size="sm" variant="outline-secondary" disabled={page.current_page <= 1} onClick={() => onChange(page.current_page - 1)}>
                <i className="fa fa-chevron-left" />
            </Button>
            <span style={{ fontSize: 12, color: 'var(--abi-muted)' }}>
                Página {page.current_page} de {page.last_page}
            </span>
            <Button size="sm" variant="outline-secondary" disabled={page.current_page >= page.last_page} onClick={() => onChange(page.current_page + 1)}>
                <i className="fa fa-chevron-right" />
            </Button>
        </div>
    );
}
